import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose, propOr } from 'ramda';
import { Container } from './markdown.styles';

export class MarkdownComponent extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
  };

  render() {
    return (
      <Container
        className={this.props.className}
        renderers={{
          listItem: ({ children }) => {
            const text = children[0].props.value;
            const label = propOr('', '0', text.match(/^\(.*\)/));
            return <li data-label={label}>{text.replace(label, '').trim()}</li>;
          },
        }}
      >
        {this.props.children}
      </Container>
    );
  }
}

export const Markdown = compose(injectIntl)(MarkdownComponent);
